import React, { useEffect, useState } from "react";
import SkeletonTable from "../../components/table/SkeletonTable.jsx";
import columns from "../../columns/followUp/followUp.js";
import {
  GetTaskWiseOrganizerApi,
  CompleteFollowUpApi,
} from "../../api/request/taskManager/taskManager.js";
import moment from "moment";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import { GetTagListApi } from "../../api/request/settings/tags.js";
import Spinner from "../../components/loaders/Spinner.jsx";
import { AddOrganizerTagApi } from "../../api/request/organizers/organizers.js";
import Eye from "../../assets/Eye.jsx";
import { useSelector } from "react-redux";
import { getSocket } from "../../services/Socket.js";

export default function FollowUp() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [tags, setTags] = useState([]);
  const socket = getSocket();
  const userDetails = useSelector((state) => state.user.userDetails);
  const getOrganizers = async () => {
    try {
      setIsLoading(true);
      let params = {
        task_order: "task4",
      };
      const { data } = await GetTaskWiseOrganizerApi(params);
      if (data?.status) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: item?.user?.name,
              email: item?.user?.email,
              organizer_id: item?.id,
              organizer: (
                <div className="font-bold highlight-text capitalize">
                  {item?.organizer_name_slug}
                </div>
              ),
              submit: item?.is_submit ? "Yes" : "No",
              is_payment:
                item?.is_payment === 0 || item?.is_payment === 1 ? (
                  "Pending"
                ) : (
                  <div
                    className="cursor-pointer text-green-500 underline"
                    onClick={() =>
                      !!item?.invoice_pdf?.url
                        ? window.open(item?.invoice_pdf?.url, "_blank")
                        : ""
                    }
                  >
                    Completed
                  </div>
                ),
              is_signature:
                item?.is_signature === 0 || item?.is_signature === 1 ? (
                  "Pending"
                ) : (
                  <div
                    className="cursor-pointer text-green-500 underline"
                    onClick={() =>
                      !!item?.organizer_pdf?.url
                        ? window.open(item?.organizer_pdf?.url, "_blank")
                        : ""
                    }
                  >
                    Completed
                  </div>
                ),
              tag: (
                <Select
                  placeholder="Select tag"
                  style={{ width: "100%" }}
                  value={item?.task_tag}
                  options={tags}
                  onChange={(value) =>
                    tagHandler(item?.id, value, item?.task_tag)
                  }
                />
              ),
              startDate: item?.submitted_date
                ? moment(item?.submitted_date).format("lll")
                : "",
              due: (
                <p
                  className={`${
                    item?.is_due ? "text-red-600" : "text-green-500"
                  }`}
                >
                  {item?.is_due ? "Yes" : "No"}
                </p>
              ),
              dueDate: item?.due_date
                ? moment(item?.due_date).format("lll")
                : "",
              status: (
                <p
                  className={`${item?.status == "active" ? "text-green-500" : "text-red-600"
                    } font-bold uppercase`}
                >
                  {item?.status}
                </p>
              ),
              action: (
                <div className="flex justify-center items-center gap-4">
                  {/* <div
                    className="cursor-pointer text-secondary"
                    onClick={() => chatHandler(item?.id)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                      />
                    </svg>
                  </div> */}

                  <div
                    className="cursor-pointer"
                    onClick={() => navigate(`/client/${item?.user_id}`)}
                  >
                    <Eye />
                  </div>

                  <div
                    className="cursor-pointer"
                    onClick={() => navigate(`/follow_up/${item?.id}`)}
                  >
                    <img
                      className="size-6"
                      src="/assets/icons/outlined-check-circle.svg"
                      alt="icon"
                    />
                  </div>
                </div>
              ),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getOrganizerTags = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetTagListApi({ type: "organizer" });
      if (data.status) {
        setTags(
          data?.data?.map((item) => {
            return { value: item?.name };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getOrganizerTags();
  }, []);

  useEffect(() => {
    getOrganizers();
    if (tags?.length > 0) {
      columns.map((item) => {
        if (item.dataIndex === "tag") {
          item.filters = tags.map((filter) => {
            return { text: filter?.value, value: filter?.value };
          });
        }
      });
    }
  }, [tags]);

  const setTagData = (id, tag) => {
    setData((prev) => {
      return prev.map((item) =>
        item.id === id
          ? {
            ...item,
            task_tag: tag,
            tag: (
              <Select
                placeholder="Select tag"
                style={{ width: "100%" }}
                value={tag}
                options={tags}
                onChange={(value) => tagHandler(item?.id, value, tag)}
              />
            ),
          }
          : item
      );
    });
  };

  const tagHandler = async (id, tag, currentTag) => {
    if (tag === currentTag) return;

    try {
      setData((prev) => {
        return prev.map((item) =>
          item.id === id ? { ...item, tag: <Spinner /> } : item
        );
      });

      let params = { org_id: id, tags: tag };
      const { data } = await AddOrganizerTagApi(params);
      if (data?.status) setTagData(id, tag);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setTagData(id, currentTag);
    }
  };

  const chatHandler = async (id) => {
    try {
      setData((prev) => {
        return prev.map((item) =>
          item.id === id ? { ...item, action: <Spinner /> } : item
        );
      });

      const { data } = await CompleteFollowUpApi({ organizer_id: id });
      if (data?.status) {
        toast.success(data?.message);
        socket.emit('updateTask', JSON.stringify({ task: 4, userId: userDetails?.id }))
        navigate("/communication");
      }
      setData((prev) => {
        return prev.map((item) =>
          item.id === id
            ? {
              ...item,
              action: (
                <div
                  className="cursor-pointer text-secondary"
                  onClick={() => chatHandler(item?.id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                    />
                  </svg>
                </div>
              ),
            }
            : item
        );
      });
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setData((prev) => {
        return prev.map((item) =>
          item.id === id
            ? {
              ...item,
              action: (
                <div
                  className="cursor-pointer text-secondary"
                  onClick={() => chatHandler(item?.id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                    />
                  </svg>
                </div>
              ),
            }
            : item
        );
      });
    }
  };

  return (
    <div>
      <div className="border-2 rounded-xl">
        <div className="mt-4 mx-5">
          <p className="font-semibold text-xl">Organizers</p>
        </div>
        <div className="table-radius-0 text-light my-4">
          <SkeletonTable
            searchingFields={["name", "email"]}
            dateFilterFields = {["startDate", "dueDate"]}
            columns={columns}
            data={data}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}
